module.exports = __webpack_public_path__ + "static/media/blank-background.6c430f05.png";